import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=d5aa1b16&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5aa1b16')) {
      api.createRecord('d5aa1b16', component.options)
    } else {
      api.reload('d5aa1b16', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=d5aa1b16&", function () {
      api.rerender('d5aa1b16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22I4Ey5vyGV0W/JS/videoIframe.vue"
export default component.exports